import api from './api';

export interface RoleConfig {
    role: string;
    displayName: string;
    permissions: Record<string, string[]>;
    pages: string[];
    menuItems: string[];
    description: string;
}

export interface AdminUser {
    uid: string;
    id: string;
    email: string;
    name: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    role: 'super_admin' | 'admin' | string;
    isSuperAdmin?: boolean;
    status: 'active' | 'passive' | string;
    createdAt?: string | null;
    updatedAt?: string | null;
}

export const rbacApi = {
    async getRoles(): Promise<RoleConfig[]> {
        try {
            const response = await api.get('/admin/rbac');
            return response.data.roles || [];
        } catch (error: any) {
            console.error('Error fetching RBAC roles:', error);
            throw new Error(error.response?.data?.error || 'RBAC verileri yüklenemedi');
        }
    },

    async updateRoles(roles: RoleConfig[]): Promise<RoleConfig[]> {
        try {
            const response = await api.put('/admin/rbac', { roles });
            return response.data.roles || [];
        } catch (error: any) {
            console.error('Error updating RBAC roles:', error);
            throw new Error(error.response?.data?.error || 'RBAC verileri güncellenemedi');
        }
    },

    async getCurrentRoleConfig(): Promise<RoleConfig> {
        try {
            const response = await api.get('/admin/rbac/me');
            return response.data;
        } catch (error: any) {
            console.error('Error fetching current RBAC role:', error);
            throw new Error(error.response?.data?.error || 'RBAC rolü yüklenemedi');
        }
    },

    async getAdminUsers(): Promise<AdminUser[]> {
        try {
            const response = await api.get('/admin/rbac/users');
            return response.data.users || [];
        } catch (error: any) {
            console.error('Error fetching admin users:', error);
            throw new Error(error.response?.data?.error || 'Admin kullanıcıları yüklenemedi');
        }
    },

    async createAdminUser(data: {
        email: string;
        password?: string;
        name: string;
        phone?: string;
        role?: 'super_admin' | 'admin';
    }): Promise<AdminUser> {
        try {
            const response = await api.post('/admin/rbac/users', data);
            return response.data.user;
        } catch (error: any) {
            console.error('Error creating admin user:', error);
            throw new Error(error.response?.data?.error || 'Admin kullanıcısı oluşturulamadı');
        }
    },

    async updateAdminUser(
        userId: string,
        data: { name?: string; phone?: string; role?: string; status?: string }
    ): Promise<void> {
        try {
            await api.put(`/admin/rbac/users/${userId}`, data);
        } catch (error: any) {
            console.error('Error updating admin user:', error);
            throw new Error(error.response?.data?.error || 'Admin kullanıcısı güncellenemedi');
        }
    },

    async changeAdminPassword(userId: string, newPassword: string): Promise<void> {
        try {
            await api.post(`/admin/rbac/users/${userId}/change-password`, { newPassword });
        } catch (error: any) {
            console.error('Error changing admin password:', error);
            throw new Error(error.response?.data?.error || 'Şifre değiştirilemedi');
        }
    },

    async deleteAdminUser(userId: string): Promise<void> {
        try {
            await api.delete(`/admin/rbac/users/${userId}`);
        } catch (error: any) {
            console.error('Error deleting admin user:', error);
            throw new Error(error.response?.data?.error || 'Admin kullanıcısı silinemedi');
        }
    },
};